<ntv-modal [grayBackground]="false" [isVisible]="isVisible()" (modalClose)="onClose()" size="large">
    <div modal-header class="modal__header">
        <h1 class="media-item__title">Media Details</h1>
        <svg class="icon icon--hoverable" width="23" height="23" (click)="onClose()">
            <use xlink:href="assets/icons/icons-sprite.svg#close"></use>
        </svg>
    </div>

    @if (item(); as item) {
        <div class="modal__body">
            <div class="media-item__preview">
                @if (item.type === 'video') {
                    <video
                        [src]="item.src"
                        preload="auto"
                        autoplay
                        controls
                        [muted]="true"
                        loop
                        playsinline></video>
                } @else {
                    <img [src]="item.src" alt="Media Preview" />
                }
            </div>
            <div class="item__controls">
                <p class="item__controls--page-info">
                    {{ currentIndex() + 1 }} / {{ totalItems() }}
                </p>
                <div class="item__controls--nav">
                    @for (nav of modalNavIcons; track nav.icon) {
                        @if (techmagicHide() && nav.icon === 'chevron-right') {
                            <svg
                                class="icon"
                                [class.disabled]="isNavDisabled(nav.checkDisabled)"
                                width="12"
                                height="12"
                                [style.transform]="
                                    nav.rotate ? 'rotate(' + nav.rotate + 'deg)' : ''
                                "
                                (click)="handleNavAction(nav.action)">
                                <use
                                    [attr.xlink:href]="
                                        'assets/icons/icons-sprite.svg#' + nav.icon
                                    "></use>
                            </svg>
                        }
                    }
                </div>
            </div>

            <div class="media-item__info">
                <div class="info__left">
                    @for (detail of mediaDetailsLeft; track detail.label) {
                        <div class="tech-item tech-item--flex-col">
                            <p class="label">{{ detail.label }}</p>
                            <p
                                class="value value--truncate"
                                [title]="
                                    resolveDetailValue(item, detail.key, undefined, detail.fallback)
                                ">
                                {{
                                    resolveDetailValue(item, detail.key, undefined, detail.fallback)
                                }}
                            </p>
                        </div>
                    }
                </div>

                <div class="info__right">
                    <h3 class="info__right--title">Technical Details</h3>
                    @for (detail of mediaDetailsRight; track detail.label) {
                        <div class="tech-item">
                            <svg class="icon" width="12" height="12">
                                <use
                                    [attr.xlink:href]="
                                        'assets/icons/icons-sprite.svg#' + detail.icon
                                    "></use>
                            </svg>
                            <span class="label">{{ detail.label }}</span>
                            <span class="value">
                                {{
                                    resolveDetailValue(
                                        item,
                                        detail.key,
                                        detail.pipe,
                                        detail.fallback,
                                        detail.pipeFormat
                                    )
                                }}
                            </span>
                        </div>
                    }
                    @if (!techmagicHide()) {
                        <div class="toggle-switch">
                            <span class="info__right--title">Set as Filler</span>
                            <ntv-toggle-button
                                [checked]="isContentFiller()"
                                color="accent_color"
                                (checkedChange)="setContentToFilter($event)" />
                        </div>
                    }
                </div>
            </div>
        </div>
    }
</ntv-modal>

<!-- Delete Confirmation Modal -->
@if (showDeleteConfirmation()) {
    <ntv-modal
        variant="success"
        [isVisible]="showDeleteConfirmation()"
        (modalClose)="cancelDelete()"
        size="small">
        <div modal-header class="modal__header--confirmation">
            <h1 class="media-item__title">Delete Confirmation</h1>
            <svg class="icon icon--hoverable" width="18" height="18" (click)="cancelDelete()">
                <use xlink:href="assets/icons/icons-sprite.svg#close"></use>
            </svg>
        </div>

        <div class="delete-confirmation__body">
            <p class="delete-confirmation__message">
                Are you sure you want to delete this media? This action cannot be undone.
            </p>
            <div class="delete-confirmation__actions">
                <ntv-button variant="accent" size="lg" (buttonClick)="cancelDelete()">
                    Cancel
                </ntv-button>
                <ntv-button variant="danger" size="lg" (buttonClick)="confirmDelete()">
                    Delete
                </ntv-button>
            </div>
        </div>
    </ntv-modal>
}
